import { useState } from "react";
import infoIconFill from "../assets/icons/info-fill-blue.svg";
import infoIconOutline from "../assets/icons/info-outline.svg";
import { twMerge } from "tailwind-merge";

interface InfoIconWithTooltipProps {
    children?: React.ReactNode;
    tooltipContent: React.ReactNode;
    hideIcon?: boolean;
    classes?: {
        root?: string;
        content?: string;
        icon?: string;
    };
}

export default function InfoIconWithTooltip({
    children,
    tooltipContent,
    hideIcon,
    classes,
}: InfoIconWithTooltipProps) {
    const [infoIcon, setInfoIcon] = useState(infoIconOutline);

    return (
        <div
            onMouseEnter={() => setInfoIcon(infoIconFill)}
            onMouseLeave={() => setInfoIcon(infoIconOutline)}
            className={`group relative h-full ml-1 w-3.5 shrink-0 grid place-content-center hover:cursor-pointer ${
                classes?.root || ""
            }`}
        >
            {children ||
                (!hideIcon && (
                    <img
                        src={infoIcon}
                        alt="info icon"
                        className={twMerge(
                            `size-3.5 shrink-0 max-w-none`,
                            classes?.icon
                        )}
                    />
                ))}
            <div
                className={`absolute flex flex-col top-6 left-[0.15rem] z-10 scale-0 group-hover:scale-100`}
            >
                <div className="relative w-0 h-0 before:content-[''] before:absolute before:border-l-[6px] before:border-r-[6px] before:border-b-[6px] before:border-l-transparent before:border-r-transparent before:border-b-[#000000]/85"></div>
                <div
                    className={`text-sm xl:text-base rounded-[4px] mt-[5px] p-2 -ml-[109px] bg-black/95 text-white font-semibold ${
                        classes?.content || ""
                    }`}
                >
                    {tooltipContent}
                </div>
            </div>
        </div>
    );
}
